import { KreProdukApiPath, MenuIds } from "../../../constants";
import { getWithMenu } from "../../../core/helpers";
export const getSearchKreProduk = async (searchParams) => {
    return await getWithMenu(KreProdukApiPath, MenuIds.FINANCE.LOAN.SETTING.PRODUK_PEMBIAYAAN.id, { page: 0, size: 500, ...searchParams });
};
